
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.6 11.5L11.286 7M6.714 7L1.4 11.5M1 3.25l6.532 4.287c.529.347.793.52 1.081.587.254.06.52.06.774 0 .288-.067.552-.24 1.081-.587L17 3.25M4.84 13h8.32c1.344 0 2.016 0 2.53-.245.451-.216.818-.56 1.048-.984.262-.48.262-1.11.262-2.371V4.6c0-1.26 0-1.89-.262-2.371a2.33 2.33 0 00-1.048-.984C15.176 1 14.504 1 13.16 1H4.84c-1.344 0-2.016 0-2.53.245a2.33 2.33 0 00-1.048.984C1 2.709 1 3.339 1 4.6v4.8c0 1.26 0 1.89.262 2.371.23.424.597.768 1.048.984C2.824 13 3.496 13 4.84 13z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    